import { Spinner } from '@intigral/shared';

const Loader = ({ styleObj = {} }) => {
    return (
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', ...styleObj }}>
            <Spinner block />
        </div>
    );
};

export default Loader;
